<template>
  <avs-card class="pb-4">
    <template #title>
      <v-toolbar class="mt-4 custom-toolbar bgTable" elevation="0">
        <v-text-field class="mr-8" clearable hide-details prepend-inner-icon="mdi-magnify"
          :label="$t('commons.search')" v-model="search" />
        <avs-createButton :spantext="$t('Ajouter une cuve')" menu :name="$t('Nouvelle cuve')" @click="openEditor()" />
      </v-toolbar>
    </template>

    <template #content>
      <v-data-table class="ma-6 bgTable" dense :headers="headers" :items="filteredItems" :search="search" :items-per-page="-1" item-key="id">
        <template #item.capacity_liters="{ item }"><b>{{ formatLiters(item.capacity_liters) }}</b></template>
        <template #item.stock_liters="{ item }"><b>{{ formatLiters(item.stock_liters) }}</b></template>
        <template #item.total_drawn_liters="{ item }"><b>{{ formatLiters(item.total_drawn_liters) }}</b></template>
        <template #item.total_refilled_liters="{ item }"><b>{{ formatLiters(item.total_refilled_liters) }}</b></template> 
        <template #item.actions="{ item }">
          <div class="d-flex justify-center">
            <avs-button icon color="primary" :iconI="'mdi-water-plus'" label fab small
              @click.stop="openRefill(item)" :spantext="$t('Ajouter un remplissage')" />
            <avs-button icon color="warning" :iconI="'mdi-tune-vertical'" label fab small
              @click.stop="openAdjust(item)" :spantext="$t('Ajuster (inventaire)')" />
            <avs-button icon color="secondary" :iconI="'mdi-history'" label fab small
              @click.stop="openHistory(item)" :spantext="$t('Historique')" />
            <avs-editButton @click.stop="openEditor(item)" :spantext="$t('actions.edit', { entity: 'cuve' })" />
            <avs-deleteButton @click.stop="confirmDelete(item)" :spantext="$t('actions.delete', { entity: 'cuve' })" />
          </div>
        </template>
      </v-data-table>

      <!-- Editor -->
      <v-dialog v-model="editorOpen" width="600">
        <v-card>
          <v-card-title>{{ current?.id ? $t('Modifier la cuve') : $t('Nouvelle cuve') }}</v-card-title>
          <v-card-text>
            <v-text-field v-model="form.name" :label="$t('commons.name')" dense required />
            <v-autocomplete v-model="form.location_shop" :items="shops" item-text="name" item-value="id"
              :label="$t('Station (LocationShop)')" dense required />
            <v-autocomplete v-model="form.product" :items="products" item-text="name" item-value="id"
              :label="$t('Produit')" dense required />
            <v-text-field v-model="form.capacity_liters" type="number" step="0.01" :label="$t('Capacité (L)')" dense />
            <v-text-field v-model="form.stock_liters" type="number" step="0.01" :label="$t('Stock initial (L)')" dense />
            <v-switch v-model="form.is_active" :label="$t('Actif')" inset />
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="editorOpen=false">{{ $t('commons.cancel') }}</v-btn>
            <v-btn color="accent" @click="saveTank">{{ $t('commons.save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Refill -->
      <v-dialog v-model="refillOpen" width="450">
        <v-card>
          <v-card-title>{{ $t('Ajouter un remplissage') }}</v-card-title>
          <v-card-text>
            <div class="mb-2 text-subtitle-2">{{ current?.name }}</div>
            <v-text-field v-model="refillForm.liters" type="number" step="0.01" :label="$t('Litres ajoutés')" dense />
            <v-text-field v-model="refillForm.note" :label="$t('Note')" dense />
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="refillOpen=false">{{ $t('commons.cancel') }}</v-btn>
            <v-btn color="accent" @click="doRefill">{{ $t('commons.validate') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Adjust -->
      <v-dialog v-model="adjustOpen" width="450">
        <v-card>
          <v-card-title>{{ $t('Ajustement d\'inventaire') }}</v-card-title>
          <v-card-text>
            <div class="mb-2 text-subtitle-2">{{ current?.name }}</div>
            <v-text-field v-model="adjustForm.liters" type="number" step="0.01" :label="$t('Litres (positif ou négatif)')" dense />
            <v-text-field v-model="adjustForm.note" :label="$t('Note')" dense />
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="adjustOpen=false">{{ $t('commons.cancel') }}</v-btn>
            <v-btn color="accent" @click="doAdjust">{{ $t('commons.validate') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- History (fullscreen) -->
      <v-dialog v-model="historyOpen" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dense flat class="history-toolbar">
        <v-spacer />
        <v-toolbar-title class="toolbar-title-center">
            {{ $t('Historique de la cuve') }} — {{ current?.name }}
        </v-toolbar-title>
            <v-spacer />
            <v-btn icon class="toolbar-close" @click="historyOpen=false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>


          <v-container>
            <v-row>
              <v-col cols="12" md="4">
                <v-select
                  v-model="filters.types"
                  :items="movementTypeItems"
                  item-text="text" item-value="value"
                  :label="$t('Types de mouvements')"
                  multiple chips clearable
                  @change="applyMovementFilters"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-menu v-model="menuFrom" :close-on-content-click="false" transition="scale-transition" max-width="290px">
                  <template #activator="{ on, attrs }">
                    <v-text-field v-model="filters.date_from" :label="$t('Date de début')" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"/>
                  </template>
                  <v-date-picker v-model="filters.date_from" @input="applyMovementFilters"/>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3">
                <v-menu v-model="menuTo" :close-on-content-click="false" transition="scale-transition" max-width="290px">
                  <template #activator="{ on, attrs }">
                    <v-text-field v-model="filters.date_to" :label="$t('Date de fin')" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"/>
                  </template>
                  <v-date-picker v-model="filters.date_to" @input="applyMovementFilters"/>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2" class="d-flex align-center">
                <v-btn outlined small class="mr-2" @click="resetMovementFilters">{{ $t('Réinitialiser') }}</v-btn>
                <v-btn color="accent" small @click="exportMovementsExcel"><v-icon left>mdi-export</v-icon> Excel</v-btn>
              </v-col>
            </v-row>

            <v-data-table
              :headers="historyHeaders"
              :items="movements"
              :loading="movementsLoading"
              :no-data-text="$t('Aucune donnée')"
              :loading-text="$t('Chargement...')"
              class="mt-4 bgTable"
              dense
              :items-per-page="-1"
            >
              <template #item.type="{ item }">
                <v-chip small :color="typeColor(item.type)" text-color="white" label>
                    {{ mapType(item.type) }}
                </v-chip>
              </template>
              <template #item.liters="{ item }">{{ formatLiters(item.liters) }} L</template>
              <template #item.created_at="{ item }">{{ toDatetime(item.created_at) }}</template>
            </v-data-table>
          </v-container>
        </v-card>
      </v-dialog>

      <DeleteDialog v-model="deleteOpen" @cancel="deleteOpen=false" @delete="doDelete" resource="Cuve" />
    </template>
  </avs-card>
</template>

<script>
import DeleteDialog from '@/components/generics/dialogs/DeleteDialog.vue'
import { ProductDetailService, ShopDetailService, TankService } from '@/services'
import * as XLSX from "xlsx"
import { saveAs } from "file-saver"

export default {
  name: 'TankList',
  components: { DeleteDialog },
  data() {
    const today = new Date()
    const yyyy = today.getFullYear(), mm = String(today.getMonth()+1).padStart(2,'0'), dd = String(today.getDate()).padStart(2,'0')
    const startMonth = `${yyyy}-${String(today.getMonth()+1).padStart(2,'0')}-01`
    return {
      search: '',
      headers: [
        { text: this.$t('commons.name'), value: 'name' },
        { text: this.$t('Station'), value: 'location_shop_name' },
        { text: this.$t('Produit'), value: 'product_name' },
        { text: this.$t('Capacité (L)'), value: 'capacity_liters' },
        { text: this.$t('Stock (L)'), value: 'stock_liters' },
        { text: this.$t('Tiré total (L)'), value: 'total_drawn_liters' },
        { text: this.$t('Ajouté total (L)'), value: 'total_refilled_liters' },
        { text: this.$t('commons.action'), value: 'actions', sortable: false, align: 'center' },
      ],
      items: [],
      products: [],
      shops: [],

      editorOpen: false,
      refillOpen: false,
      adjustOpen: false,
      deleteOpen: false,
      historyOpen: false,

      current: null,
      form: { name: '', location_shop: null, product: null, capacity_liters: '', stock_liters: '', is_active: true },
      refillForm: { liters: '', note: '' },
      adjustForm: { liters: '', note: '' },

      // History
      historyHeaders: [
        { text: this.$t('Type'), value: 'type' },
        { text: this.$t('Litres'), value: 'liters' },
        { text: this.$t('Note'), value: 'note' },
        { text: this.$t('Date'), value: 'created_at' },
      ],
      movements: [],
      movementsLoading: false,
      movementTypeItems: [
        { text: this.$t('Ajustements'), value: 'adjust' },
        { text: this.$t('Remplissages'), value: 'refill' },
        { text: this.$t('Sorties'), value: 'draw' },
      ],
      filters: {
        types: [],                     // multiple
        date_from: startMonth,         // début mois
        date_to: `${yyyy}-${mm}-${dd}` // aujourd'hui
      },
      menuFrom: false,
      menuTo: false,
    }
  },
  computed: {
    filteredItems() { return this.items }, // hook si tu veux filtrer côté client
  },
  created() {
    this.fetchAll()
  },
  methods: {
    typeColor(t) {
        const k = String(t || '').toLowerCase()
        if (k === 'refill') return 'success' // vert
        if (k === 'draw')   return 'error'   // rouge
        if (k === 'adjust') return 'warning' // orange
        return 'primary'
    },

    formatLiters(v) { return Number(v || 0).toLocaleString() },
    toDatetime(s) {
      if (!s) return ''
      const d = new Date(s)
      return d.toLocaleString()
    },
    mapType(t) {
      const k = String(t || '').toLowerCase()
      if (k === 'refill') return this.$t('Remplissage')
      if (k === 'draw')   return this.$t('Sortie')
      if (k === 'adjust') return this.$t('Ajustement')
      return t
    },

    fetchAll() {
      TankService.list().then(d => { this.items = d })
      ProductDetailService.getAll(this).then(d => { this.products = d })
      ShopDetailService.getAll(this).then(d => { this.shops = d })
    },

    openEditor(item) {
      this.current = item || null
      this.form = item ? {
        name: item.name,
        location_shop: item.location_shop?.id,
        product: item.product?.id,
        capacity_liters: item.capacity_liters,
        stock_liters: item.stock_liters,
        is_active: !!item.is_active,
      } : { name: '', location_shop: null, product: null, capacity_liters: '', stock_liters: '', is_active: true }
      this.editorOpen = true
    },
    saveTank() {
      const payload = { ...this.form }
      const req = this.current ? TankService.update(this, this.current.id, payload) : TankService.create(this, payload)
      req.then(() => { this.editorOpen = false; this.fetchAll(); this.send(this.$t('messages.success.operation'), 'success') })
        .catch(e => this.send(e?.response?.data?.detail || this.$t('messages.error.operation_failed'), 'error'))
    },

    openRefill(item) { this.current = item; this.refillForm = { liters: '', note: '' }; this.refillOpen = true },
    doRefill() {
      TankService.refill(this, this.current.id, this.refillForm)
        .then(() => { this.refillOpen = false; this.fetchAll(); this.send(this.$t('messages.success.operation'), 'success') })
        .catch(e => this.send(e?.response?.data?.detail || this.$t('messages.error.operation_failed'), 'error'))
    },

    openAdjust(item) { this.current = item; this.adjustForm = { liters: '', note: '' }; this.adjustOpen = true },
    doAdjust() {  // ← appel TankService.adjust ici
      TankService.adjust(this, this.current.id, this.adjustForm)
        .then(() => { this.adjustOpen = false; this.fetchAll(); this.send(this.$t('messages.success.operation'), 'success') })
        .catch(e => this.send(e?.response?.data?.detail || this.$t('messages.error.operation_failed'), 'error'))
    },

    confirmDelete(item) { this.current = item; this.deleteOpen = true },
    doDelete() {
      TankService.remove(this, this.current.id)
        .then(() => { this.deleteOpen = false; this.fetchAll(); this.send(this.$t('messages.success.operation'), 'success') })
        .catch(e => this.send(e?.response?.data?.detail || this.$t('messages.error.operation_failed'), 'error'))
    },

    openHistory(item) { this.current = item; this.historyOpen = true; this.fetchMovements() },
    resetMovementFilters() {
      const t = new Date()
      const yyyy = t.getFullYear(), mm = String(t.getMonth()+1).padStart(2,'0'), dd = String(t.getDate()).padStart(2,'0')
      this.filters.types = []
      this.filters.date_from = `${yyyy}-${mm}-01`
      this.filters.date_to = `${yyyy}-${mm}-${dd}`
      this.fetchMovements()
    },
    applyMovementFilters() { this.fetchMovements() },
    fetchMovements() {
      this.movementsLoading = true
      const params = {
        no_pagination: true,
        date_from: this.filters.date_from || undefined,
        date_to: this.filters.date_to || undefined,
        types: (this.filters.types && this.filters.types.length) ? this.filters.types.join(',') : undefined,
      }
      TankService.movements(this, this.current.id, params)
        .then((rows) => { this.movements = rows || [] })
        .catch(e => this.send(e?.response?.data?.detail || this.$t('messages.error.operation_failed'), 'error'))
        .finally(() => { this.movementsLoading = false })
    },

    exportMovementsExcel() {
      if (!this.movements || !this.movements.length) {
        this.send(this.$t('messages.warning.no_data_to_export'), 'warning')
        return
      }
      const rows = [
        [this.$t('Type'), this.$t('Litres'), this.$t('Note'), this.$t('Date')]
      ]
      this.movements.forEach(m => {
        rows.push([
          this.mapType(m.type),
          Number(m.liters || 0),
          m.note || '',
          this.toDatetime(m.created_at)
        ])
      })
      const ws = XLSX.utils.aoa_to_sheet(rows)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, "Mouvements")
      const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" })
      saveAs(new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
             `historique_cuve_${this.current?.name || ''}.xlsx`)
      this.send(this.$t('Téléchargé avec succès'), 'success')
    },

    send(msg, color) { this.$store.commit('app/message', { msg, color }) }
  }
}
</script>

<style scoped>
.custom-toolbar { margin-top: 20px; padding-top: 10px; padding-right: 0; padding-left: 0; }
.history-toolbar { position: relative; }
.toolbar-title-center { width: 100%; text-align: center; }
.toolbar-close { position: absolute; right: 8px; }

</style>
